/**
 * Preferencia da "bolinha fixa" do medir 2 pontos.
 *
 * Automatica: tela de toque (tablet, celular — e caneta, que o navegador trata
 * igual) comeca LIGADA, porque o dedo cobre o ponto e nao existe "passar o mouse
 * por cima" para ver onde vai marcar. Computador comeca desligada (a bolinha
 * segue o mouse, como sempre foi). Se a pessoa mudar, fica gravado neste
 * navegador.
 */
const CHAVE = 'mania3d.bolinhaFixa';

export function aparelhoDeToque(): boolean {
  return typeof matchMedia === 'function' && matchMedia('(pointer: coarse)').matches;
}

export function lerBolinhaFixa(): boolean {
  try {
    const v = localStorage.getItem(CHAVE);
    if (v === '1') return true;
    if (v === '0') return false;
  } catch {
    // aba anonima/armazenamento bloqueado: fica no automatico
  }
  return aparelhoDeToque();
}

export function gravarBolinhaFixa(on: boolean): void {
  try {
    localStorage.setItem(CHAVE, on ? '1' : '0');
  } catch {
    // sem armazenamento: vale so ate fechar a pagina
  }
}
